var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { spinner } from "./assets/spinner";
class PostsSection {
    constructor(section) {
        this.section = section;
        this.currentPage = 1;
        this.select = section.querySelector("select.filter");
        this.loadMoreButton = section.querySelector("#load_more");
        this.afterHandleResponse = this.afterHandleResponse.bind(this);
        this.append = this.append.bind(this);
        this.postsPerPage = this.section.dataset.postsPerPage;
        this.noMsgWrapper = this.section.querySelector("#noResultsMsgWrapper");
        this.currentTag = "";
        this.init();
    }
    init() {
        this.removeEventListeners();
        this.addEventListeners();
    }
    addEventListeners() {
        if (this.select)
            this.select.addEventListener("change", this.handleSelectChange.bind(this));
        if (this.loadMoreButton)
            this.loadMoreButton.addEventListener("click", this.handleClick.bind(this));
    }
    removeEventListeners() {
        if (this.select)
            this.select.removeEventListener("change", this.handleSelectChange);
        if (this.loadMoreButton)
            this.loadMoreButton.removeEventListener("click", this.handleSelectChange);
    }
    handleClick() {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentPage++;
            try {
                const response = yield fetch("/wp-json/api/v1/load-more", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        action: "oim_load_more",
                        paged: this.currentPage,
                        type: this.section.dataset.postType,
                        tag: this.currentTag,
                        posts_per_page: this.postsPerPage,
                        lang: this.section.dataset.lang,
                    }),
                });
                const res = yield response.json();
                this.submit(res, "append");
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    handleSelectChange({ target }) {
        return __awaiter(this, void 0, void 0, function* () {
            this.noMsgWrapper.classList.add("d-none");
            this.currentTag = target.value;
            if (this.currentTag === "all") {
                this.currentPage = 1;
            }
            else {
                this.currentPage = 1;
            }
            const row = this.section.querySelector("#posts");
            let height = row.clientHeight ? row.clientHeight : 110;
            const loadingWrapper = document.createElement("div");
            loadingWrapper.style.height = height.toString() + "px";
            loadingWrapper.style.width = "100%";
            loadingWrapper.style.display = "flex";
            loadingWrapper.style.justifyContent = "center";
            loadingWrapper.style.alignItems = "start";
            loadingWrapper.innerHTML = spinner;
            row.replaceChildren(loadingWrapper);
            try {
                const response = yield fetch("/wp-json/api/v1/load-more", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        action: "oim_load_more",
                        paged: this.currentPage,
                        type: this.section.dataset.postType,
                        tag: this.currentTag,
                        posts_per_page: this.postsPerPage,
                        lang: this.section.dataset.lang,
                    }),
                });
                const res = yield response.json();
                this.submit(res, "replace");
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    submit(res, type) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const parser = new DOMParser();
                const html = parser.parseFromString(res.html, "text/html");
                const cards = html.querySelectorAll(".post-card");
                if (type === "replace") {
                    this.replace(cards);
                }
                else {
                    this.append(cards);
                }
                if (this.loadMoreButton) {
                    if (this.currentPage >= res.max) {
                        this.loadMoreButton.classList.add("d-none");
                    }
                    else {
                        this.loadMoreButton.classList.remove("d-none");
                    }
                }
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    replace(cards) {
        return __awaiter(this, void 0, void 0, function* () {
            const row = this.section.querySelector("#posts");
            this.currentPage = 1;
            row.innerHTML = "";
            if (!cards.length) {
                this.showNoPostsMsg();
            }
            cards.forEach((card) => {
                row === null || row === void 0 ? void 0 : row.append(card);
            });
            this.afterHandleResponse(cards);
        });
    }
    append(cards) {
        return __awaiter(this, void 0, void 0, function* () {
            const row = this.section.querySelector("#posts");
            cards.forEach((card) => {
                row === null || row === void 0 ? void 0 : row.append(card);
            });
            this.afterHandleResponse(cards);
        });
    }
    afterHandleResponse(cards) {
        cards.forEach((card, i) => {
            setTimeout(() => {
                card.classList.add("visible");
            }, (i + 1) * 100);
        });
    }
    showNoPostsMsg() {
        this.noMsgWrapper.classList.remove("d-none");
        const msg = this.section.querySelector("#noResultsMsg");
        msg.insertAdjacentText("beforeend", " " + this.currentTag.charAt(0).toUpperCase() + this.currentTag.slice(1));
    }
}
export const initPostsSection = () => document
    .querySelectorAll(".posts-section")
    .forEach((section) => new PostsSection(section));
